import request from 'utils/request'

/**
 * 获取限额延期批量申请审批详情
 * @param {*} id
 */
export const getBatchPeriodDetail = id =>
request().get(`periodBatch/task/detail/${id}`)

/**
 * 限额延期提交批量申请审批
 * @param {*} data
 */
export const doPeriodBatchApprove = data => request().post('periodBatch/approve', data)

/**
 * 检验是否为标准账期
 * @param {*} data
 */
export const periodCheck = data => request().post('periodBatch/approve/termList/check', data)

/**
 * 下载批量文件
 * @param {*} id
 */
export const downloadPeriodBatchFile = id =>
  request().get(`periodBatch/download/${id}`, { responseType: 'blob' })

/**
 * 获取批量申请待审批列表
 * @param {*} data
 */
export const getBatchAuditList = data =>
request().post('periodBatch/task/page', data)

export const getBatchRecordList = data =>
  request().post('periodBatch/approve/page', data)

export const exportRecord = data =>
  request().post('periodBatchh/approve/export', data, {
    responseType: 'arraybuffer',
})
